module.exports = __webpack_public_path__ + "static/media/Proff_720x270.616b7908.png";